const uspMobile = {
  type: 'Usp',
  props: {
    css: {
      padding: '0 24px',
      bg: 'transparent',
      boxShadow: 'none',
      svg: {
        margin: 0,
      },
      div: {
        gap: '4px',
        marginBottom: '4px !important',
        alignItems: 'center',
        '>p': {
          color: 'main.2',
        },
      },
    },
    display: ['block', null, 'none'],
    my: [4, null, 0],
    marginBottom: ['80px', '80px', 0, 0],
    items: [
      'Met gratis opzegservice',
      '14 dagen bedenktijd',
      'Binnen 2 minuten geregeld',
    ],
    iconVerticalAlignment: 'start',
  },
};

export default uspMobile;
